import React from 'react';
import {BrowserRouter as Router, Switch} from 'react-router-dom';

import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

import Main from './modules/main/Main';
import Login from './modules/login/Login';
import Register from './modules/register/Register';
import HolidayApprove from './modules/attendance/HolidayApprove';
import WorkApprove from './modules/attendance/WorkApprove';
import GeneralApprove from './modules/attendance/GeneralApprove';
import ForgetPassword from './modules/forgot-password/ForgotPassword';
import RecoverPassword from './modules/recover-password/RecoverPassword';
import PrivacyPolicy from './modules/privacy-policy/PrivacyPolicy';
import PublicRoute from './routes/PublicRoute';
import PrivateRoute from './routes/PrivateRoute';
import './App.scss';

const cache = createCache({ key: 'my-unique-cache' });

const App = () => {
    return (
        <CacheProvider value={cache}>
        <Router>
            <Switch>
                <PublicRoute exact path="/login">
                    <Login />
                </PublicRoute>
                <PublicRoute exact path="/holidayApprove">
                    <HolidayApprove />
                </PublicRoute>
                <PublicRoute exact path="/workApprove">
                    <WorkApprove />
                </PublicRoute>
                <PublicRoute exact path="/generalApprove">
                    <GeneralApprove />
                </PublicRoute>
                <PublicRoute exact path="/register">
                    <Register />
                </PublicRoute>
                <PublicRoute exact path="/forgot-password">
                    <ForgetPassword />
                </PublicRoute>
                <PublicRoute exact path="/recover-password">
                    <RecoverPassword />
                </PublicRoute>
                <PublicRoute exact path="/privacy-policy">
                    <PrivacyPolicy />
                </PublicRoute>
                <PublicRoute exact path="/callback">
                    <h1>Callback</h1>
                </PublicRoute>
                <PrivateRoute path="/">
                    <Main />
                </PrivateRoute>
            </Switch>
        </Router>
        </CacheProvider>
    );
};

export default App;